import type { ReactNode } from 'react';

export function Skeleton({ height = 16, width = '100%', radius = 6 }: { height?: number | string; width?: number | string; radius?: number }) {
  return <div className="skeleton" style={{ height, width, borderRadius: radius }} />;
}

export function ChartSkeleton({ height = 320 }: { height?: number }) {
  return (
    <div className="chart-container">
      <Skeleton height={20} width="40%" />
      <div style={{ marginTop: 16 }}>
        <Skeleton height={height} radius={8} />
      </div>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="error">
      <span>{message}</span>
      {onRetry && (
        <button className="btn btn-ghost btn-sm" onClick={onRetry} style={{ marginLeft: 12 }}>
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export function Badge({ children, tone = 'neutral' }: { children: ReactNode; tone?: 'neutral' | 'green' | 'blue' | 'yellow' | 'purple' }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}
